import type { RouteRecordRaw } from 'vue-router'

import { ROUTE_NAMES } from '~/constants/routes'

import translations from './pages/Index.translations'

const routes = (): RouteRecordRaw[] => {
  return [
    {
      name: ROUTE_NAMES.ORDERS.INDEX,
      path: '/bo-seller/orders',
      component: () => import('~/scopes/orders/pages/Index.vue'),
      redirect: { name: ROUTE_NAMES.ORDERS.TABS.ALL },
      meta: {
        autonomousBannerPageName: 'orders',
        owners: ['bot-squad-seller-experience-front'],
      },
      children: [
        {
          name: ROUTE_NAMES.ORDERS.TABS.ALL,
          component: () =>
            import('~/scopes/orders/pages/components/Tab/Tab.vue'),
          path: 'all',
          meta: {
            autonomousBannerPageName: 'orders.all',
            tabItem: {
              label: translations.tabAll,
            },
            owners: ['bot-squad-seller-experience-front'],
          },
        },
        {
          name: ROUTE_NAMES.ORDERS.TABS.NEW,
          component: () =>
            import('~/scopes/orders/pages/components/Tab/Tab.vue'),
          path: 'new',
          meta: {
            autonomousBannerPageName: 'orders.new',
            tabItem: {
              label: translations.tabNew,
            },
            owners: ['bot-squad-seller-experience-front'],
          },
        },
        {
          name: ROUTE_NAMES.ORDERS.TABS.PENDING,
          component: () =>
            import('~/scopes/orders/pages/components/Tab/Tab.vue'),
          path: 'pending',
          meta: {
            autonomousBannerPageName: 'orders.pending',
            tabItem: {
              label: translations.tabPending,
            },
            owners: ['bot-squad-seller-experience-front'],
          },
        },
        {
          name: ROUTE_NAMES.ORDERS.TABS.NEEDING_RESPONSE,
          component: () =>
            import('~/scopes/orders/pages/components/Tab/Tab.vue'),
          path: 'needing-response',
          meta: {
            autonomousBannerPageName: 'orders.needing-response',
            tabItem: {
              label: translations.tabNeedingResponse,
            },
            owners: ['bot-squad-seller-experience-front'],
          },
        },
      ],
    },
  ]
}

export default routes
